import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { I18nProvider, useI18n } from "@/lib/i18n";
import { useEffect } from "react";
import Landing from "@/pages/Landing";
import Dashboard from "@/pages/Dashboard";
import Admin from "@/pages/Admin";
import PaymentSuccess from "@/pages/PaymentSuccess";
import ResetPassword from "@/pages/ResetPassword";
import { CGV, Legal } from "@/pages/Legal";

function Loading() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-[#0A0A0A]">
      <div className="font-mono-clock text-[#007BFF] text-glow-blue text-2xl gt-live-dot">GaimTime</div>
    </div>
  );
}

function Protected({ children, admin }) {
  const { user, ready } = useAuth();
  if (!ready) return <Loading />;
  if (!user) return <Navigate to="/" replace />;
  if (admin && !user.is_admin) return <Navigate to="/dashboard" replace />;
  return children;
}

function LangSync() {
  const { user } = useAuth();
  const { lang, setLang } = useI18n();
  useEffect(() => {
    if (user && user.language && user.language !== lang) {
      setLang(user.language);
    }
  }, [user, lang, setLang]);
  return null;
}

function App() {
  return (
    <div className="App">
      <I18nProvider>
        <AuthProvider>
          <LangSync />
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<Landing />} />
              <Route path="/cgv" element={<CGV />} />
              <Route path="/mentions-legales" element={<Legal />} />
              <Route path="/payment-success" element={<PaymentSuccess />} />
              <Route path="/reset-password" element={<ResetPassword />} />
              <Route path="/dashboard" element={<Protected><Dashboard /></Protected>} />
              <Route path="/admin" element={<Protected admin><Admin /></Protected>} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </BrowserRouter>
          <Toaster theme="dark" position="top-center" richColors />
        </AuthProvider>
      </I18nProvider>
    </div>
  );
}

export default App;
